import React from "react";
import FixedDecimal from "./fixed-decimal";

export default function Share(props) {
  const { value } = props;
  return <FixedDecimal value={value} precision={3} />;
}
